import { NavigateOptions, To, useNavigate as useRouterNavigate } from 'react-router-dom'
import { useUpdateSearchParams } from './Link'

export { useLocation, createSearchParams, useSearchParams } from 'react-router-dom'
export { Link, NavLink } from './Link'
export { Outlet, useParams } from 'react-router'
export { FilterNavigate as Navigate } from './Location'

export function useNavigate() {
  const nav = useRouterNavigate()
  const update = useUpdateSearchParams()

  function navigate(arg0: To | number, arg1?: NavigateOptions) {
    if (typeof arg0 === 'number') {
      return nav(arg0)
    } else {
      const updated: To = update(arg0)
      return nav(updated, arg1)
    }
  }

  return navigate
}
